import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryService } from '../../linq-utils/repository.service';
import { LinqException } from '../../common/exceptions';
import { screenForUrl } from './help-chat-text';

export interface HelpChatMessage {
    role: 'user' | 'assistant'
    content: string
}

// as the server takes them
export const HELP_CHAT_MAX_CHARS = 2000
const HELP_CHAT_SENT = 20

// the help chat's conversation, kept while the user moves around the app so they can come back to it. The server
// keeps nothing, so each question goes with the conversation so far
@Injectable({ providedIn: 'root' })
export class HelpChatService {
    messages:HelpChatMessage[] = []
    asking = false
    error = ''

    constructor(private repoService:RepositoryService, private router:Router) {}

    async ask(question:string) {
        const content = question.trim().slice(0, HELP_CHAT_MAX_CHARS)
        if (!content || this.asking) return
        this.messages = [...this.messages, {role: 'user', content}]
        await this.send()
    }

    // asks again after a problem, with the question still unanswered
    async retry() {
        if (this.asking || this.messages[this.messages.length - 1]?.role !== 'user') return
        await this.send()
    }

    newChat() {
        if (this.asking) return
        this.messages = []
        this.error = ''
    }

    private async send() {
        this.asking = true
        this.error = ''
        try {
            const body = {messages: this.messages.slice(-HELP_CHAT_SENT), screen: screenForUrl(this.router.url)}
            const result = await this.repoService.callSingleAPI(this.repoService.create('api/ai/help', body), "Help chat", "Ask help assistant", undefined, undefined, undefined, undefined, false)
            const answer = typeof result?.answer === 'string' ? result.answer.trim() : ''
            if (!answer) throw new Error("No answer")
            this.messages = [...this.messages, {role: 'assistant', content: answer}]
        }catch(err) {
            this.error = (err as LinqException)?.httpStatus === 429
                ? "You've asked a lot of questions in a short time. Please wait a few minutes and try again."
                : "LINQ AI couldn't answer just now. Please try again."
        }finally {
            this.asking = false
        }
    }
}
